import * as React from "react";
import Loadable from "react-loadable";

export const CreatePitchModal = Loadable({
  loader: () => import("../../../modules/manage-pitch").then((module) => module.CreatePitchModal) as Promise<any>,
  loading: () => <div>Loading Scripts...</div>,
});
